import { useNavigate } from 'react-router-dom'

import { BaseView } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'

export const ProfileQRCode = () => {
  const navigate = useNavigate()

  return (
    <BaseView
      style={{ cursor: 'pointer' }}
      onClick={() => navigate('/share-qr')}
    >
      <AppIcons name="qrCode" />
    </BaseView>
  )
}
